if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    const { InspectorControls } = window.wp.editor;
    const { PanelBody, TextControl } = window.wp.components;

    function renderRibbon(text) {
        const items = text.split('\n').slice(0, 4).map(item => item.trim()).filter(item => item);

        return (
            <div className="ribbon">
                <div className="ribbon-track">
                    { [0, 1].map(group => (
                        <div key={ group } className="ribbon-group" aria-hidden={ group ? true : undefined }>
                            { [0, 1].map(repeat => (
                                <span key={ repeat } className="ribbon-repeat" aria-hidden={ repeat ? true : undefined }>
                                    { items.map((item, index) => (
                                        <span key={ index } className="ribbon-item">
                                            <span>{ item }</span>
                                            <span className="ribbon-dot" aria-hidden="true">·</span>
                                        </span>
                                    )) }
                                </span>
                            )) }
                        </div>
                    )) }
                </div>
            </div>
        );
    }

    registerBlockType('custom-gutenberg/ribbon', {
        title: 'Ribbon',
        description: 'Animated ribbon with editable text.',
        icon: 'leftright',
        category: 'custom-content',
        example: {},

        attributes: {
            text: {
                type: 'string',
                default: 'TERENSKA VOŽNJA\nSKRIVENA ISTRA\nLOKALNI OKUSI\nPRAVI DOŽIVLJAJ'
            }
        },

        edit({ attributes, setAttributes }) {
            const items = attributes.text.split('\n').slice(0, 4);

            function onItemChange(index, value) {
                const updated = [0, 1, 2, 3].map(i => items[i] || '');
                updated[index] = value.replace(/[\r\n]/g, ' ');
                setAttributes({ text: updated.join('\n') });
            }

            return ([
                <InspectorControls key="settings">
                    <PanelBody title="Ribbon text">
                        { [0, 1, 2, 3].map(index => (
                            <TextControl
                                key={ index }
                                label={ 'Word ' + (index + 1) }
                                value={ items[index] || '' }
                                onChange={ value => onItemChange(index, value) }
                            />
                        )) }
                    </PanelBody>
                </InspectorControls>,
                <div key="preview">{ renderRibbon(attributes.text) }</div>
            ]);
        },

        save({ attributes }) {
            return renderRibbon(attributes.text);
        }
    });
}
